import {createSlice} from '@reduxjs/toolkit';
import {
  deviceRegisterAPI,
} from '../api/registerAPI';

const initialState = {
};

export const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
  },
});

export const deviceRegister = (data, callback) => async (dispatch, getState) => {
  const response = await deviceRegisterAPI(data)
  if (callback) callback(response)
  return response;
};

export default registerSlice.reducer;
